import { config } from 'util/config';
import { httpClient } from 'util/Api';
import * as globalFunction from 'util/GlobalFunction';

function getPresetSection(sectionComponent) {
  if (Array.isArray(sectionComponent?.child)) {
    const child = sectionComponent.child.find(item =>
      item?.current?.props?.sectionName === 'WorkflowStatusPreset' ||
      item?.current?.child?.current?.props?.sectionName === 'WorkflowStatusPreset');
    return child?.current || null;
  }
  return sectionComponent;
}

export function clearWorkflowStatusPresetSelection({ formComponent, sectionComponent } = {}) {
  const customForm = formComponent || sectionComponent?.customForm?.current;
  const selector = customForm?.additionalFormRef?.current?.child?.current;

  // 弹窗实例会被复用，关闭时清空数据和受控选中项，避免下次打开闪现旧 Preset。
  selector?.setState({
    data: [],
    filteredData: [],
    selectedRowKeys: [],
    workflowStatusPresetContentList: [],
  });
  customForm?.formRef?.current?.setFieldsValue({ WorkflowStatusPresetContentList: [] });
}

export function cancelCustomForm({ sectionComponent } = {}) {
  clearWorkflowStatusPresetSelection({ sectionComponent });
  sectionComponent.setState({
    showModal: false,
    customFormSubmitting: false,
    isFormModified: false,
    componentType: null,
  });

  setTimeout(() => {
    sectionComponent?.customForm?.current?.resetFields();
  }, config.setTimeoutMilliSecond);
}

export function addBySection({ sectionComponent } = {}) {
  const presetSection = getPresetSection(sectionComponent);
  if (!presetSection) {
    return;
  }

  clearWorkflowStatusPresetSelection({ sectionComponent: presetSection });
  presetSection.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    const selector = presetSection.customForm?.current
      ?.additionalFormRef?.current?.child?.current;
    selector?.getWorkflowStatusData();
  }, config.setTimeoutMilliSecond * 10);
}

export function editBySection({
  parameter,
  sectionComponent,
  pageComponent,
  sectionName,
} = {}) {
  clearWorkflowStatusPresetSelection({ sectionComponent });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });

  setTimeout(() => {
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (!data.result) {
          globalFunction.handleResultError(data, pageComponent);
          return;
        }

        const customForm = sectionComponent.customForm?.current;
        customForm?.setState({ currentDataKey: data.data.key, formData: data.data });
        customForm?.formRef.current?.setFieldsValue(data.data);

        const contentList = data.data.WorkflowStatusPresetContentList || [];
        const selectedRowKeys = contentList.map(item => item.WorkflowStatusId);

        setTimeout(() => {
          const selector = customForm?.additionalFormRef?.current?.child?.current;
          selector?.setState({
            workflowStatusPresetContentList: contentList,
            // Table 使用受控选中项，首次打开编辑弹窗即可显示当前 Preset 的内容。
            selectedRowKeys,
          });
          selector?.getWorkflowStatusData();
        }, config.setTimeoutMilliSecond * 10);
      })
      .catch(error => {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

export function showSelectedItemsOnlyOnChange({ parameter, sectionComponent } = {}) {
  const selector = sectionComponent?.customForm?.current
    ?.additionalFormRef?.current?.child?.current;
  if (!selector) {
    return;
  }

  const selectedIds = selector.state.workflowStatusPresetContentList
    .map(item => item.WorkflowStatusId);
  const filteredData = parameter
    ? selector.state.data.filter(item => selectedIds.includes(item.key))
    : selector.state.data;
  selector.setState({ filteredData });
}
